import classNames from "classnames";
import { FunctionComponent } from "react";

interface ButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  variant?: "primary" | "secondary" | "secondary-red";
}

const Button: FunctionComponent<ButtonProps> = ({ variant = "primary", className, ...buttonProps }) => {
  return (
    <button
      {...buttonProps}
      className={classNames(
        className,
        "h-[42px] rounded-lg flex items-center justify-center hover:opacity-90 transform active:scale-95 cursor-pointer select-none transition",
        {
          "bg-gradient-to-r from-main-from to-main-to text-white": variant === "primary",
          "border-main-from border text-main-from hover:bg-gradient-to-r hover:from-main-from hover:to-main-to hover:text-white":
            variant === "secondary",
          "border-red-600 border text-red-600 hover:bg-red-600 hover:text-white": variant === "secondary-red",
        }
      )}
    ></button>
  );
};

export default Button;
